import loadable from '@loadable/component'

export const ScrollbarWithTimeout = loadable(
  () => import('./ScrollbarWithTimeout')
)
export default ScrollbarWithTimeout
